import axios from 'utils/axios';
import {URLS} from 'utils/constants';
import crashLogger from 'utils/logger';
const baseURL = URLS.ORDERHUB_BASE_URL;

export const getOrderTemplates = async query => {
	try {
		const {limit, page, search, sortBy, sortOrder} = query;
		const params = {
			limit,
			offset: Number((page) * limit) || null,
			...search,
			sortBy,
			sortOrder,
		};
		const {data} = await axios({
			method: 'GET',
			url: `${baseURL}/order-template/list`,
			params,
		});
		return data;
	} catch (error) {
		crashLogger.error(error);
		throw error;
	}
};

export const getActiveMenuTemplate = async params => {
	try {

		const {data} = await axios({
			method: 'GET',
			url: `${baseURL}/order-template/menu-template`,
			params,
		});
		return data;
	} catch (error) {
		crashLogger.error(error);
		throw error;
	}
};

export const createNewOrderTemplate = async payload => {
	try {
		const {data} = await axios({
			method: 'POST',
			url: `${baseURL}/order-template/create`,
			data: payload,
		});
		return data;
	} catch (error) {
		crashLogger.error(error);
		throw error;
	}
};

export const editOrderTemplate = async payload => {
	try {
		const {data} = await axios({
			method: 'PUT',
			url: `${baseURL}/order-template/update`,
			data: payload,
		});
		return data;
	} catch (error) {
		crashLogger.error(error);
		throw error;
	}
};

export const deleteOrderTemplate = async payload => {
	try {
		const {data} = await axios({
			method: 'DELETE',
			url: `${baseURL}/order-template/delete`,
			data: payload,
		});
		return data;
	} catch (error) {
		crashLogger.error(error);
		throw error;
	}
};

export const getCampaignList = async query => {
	try {
		const {limit, page, search, sortBy, sortOrder} = query;
		const params = {
			limit,
			offset: Number((page) * limit) || null,
			...search,
			sortBy,
			sortOrder,
		};
		const {data} = await axios({
			method: 'GET',
			url: `${baseURL}/order/internal/campaign/list`,
			params,
		});
		return data;
	} catch (error) {
		crashLogger.error(error);
		throw error;
	}
};

export const createNewCampaign = async payload => {
	try {
		const {data} = await axios({
			method: 'POST',
			url: `${baseURL}/order/internal/campaign/create`,
			data: payload,
		});
		return data;
	} catch (error) {
		crashLogger.error(error);
		throw error;
	}
};

export const editCampaign = async payload => {
	try {
		const {data} = await axios({
			method: 'PUT',
			url: `${baseURL}/order/internal/campaign/update`,
			data: payload,
		});
		return data;
	} catch (error) {
		crashLogger.error(error);
		throw error;
	}
};